import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import usePageContent from '../../../hooks/usePageContent';

// Components
import Meta from '../../shared/Meta';
import TermsText from '../../shared/TermsText';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function Terms() {
  const { site_title } = useContext(ConfigContext);
  const { content: cms } = usePageContent('misc_terms');

  return (
    <div>
      <Meta
        title={cms?.meta?.title || `Terms & Conditions`}
        description={cms?.meta?.description}
        breadcrumbName='Terms & Conditions'
      />
      <h1 className={styles.PrivacyPage_header}>Terms & Conditions</h1>
      <TermsText className={styles.AboutPage_body} />
    </div>
  );
}

export default Terms;
